import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { BoxArrowRight, HouseDoor, List } from 'react-bootstrap-icons';
import './AdminNavbar.css';
import { useNavigate } from 'react-router-dom';

export default function AdminNavbar({ nombreSesion, handleLogout, rolSesion }) {
    const [menuOpen, setMenuOpen] = useState(false);
    const navigate = useNavigate();

    return (
        <header className="ap_admin-header">
            {/* Logo */}
            <img
                src="/img/iconb.png"
                alt="Logo" className="ap_admin-logo" />

            {/* Título */}
            <div className="ap_admin-title">
                <h2>{rolSesion === 'director' ? 'Panel de Dirección' : 'Panel de Administración'}</h2>
            </div>

            {/* Menú hamburguesa para móviles */}
            <div className="ap_admin-menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
                <List size={28} />
            </div>

            {/* Botones y sesión */}
            <div className={`ap_admin-actions ${menuOpen ? 'open' : ''}`}>
                {nombreSesion && (
                    <div className="ap_admin-session">Sesión: {nombreSesion}</div>
                )}
                <Button
                    variant="secondary"
                    onClick={() => {
                        setMenuOpen(false);
                        navigate('/');
                    }}
                >
                    <HouseDoor /> Home
                </Button>
                <Button
                    variant="danger"
                    onClick={() => {
                        setMenuOpen(false);
                        handleLogout();
                    }}
                >
                    <BoxArrowRight /> Cerrar Sesión
                </Button>
            </div>
        </header>
    );
}
